/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multimedia_LinkInputs */

const en_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multimedia Link`)
};

const es_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace multimedia`)
};

const fr_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien multimédia`)
};

const de_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multimedia-Link`)
};

const ja_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マルチメディアリンク`)
};

const zh_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多媒体链接`)
};

const ar_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط وسائط متعددة`)
};

const id_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Multimedia`)
};

const it_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link multimediale`)
};

const ru_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мультимедийная ссылка`)
};

const pt_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link multimídia`)
};

const ko_multimedia_link = /** @type {(inputs: Multimedia_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`멀티미디어 링크`)
};

/**
* | output |
* | --- |
* | "Multimedia Link" |
*
* @param {Multimedia_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const multimedia_link = /** @type {((inputs?: Multimedia_LinkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multimedia_LinkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_multimedia_link(inputs)
	if (locale === "es") return es_multimedia_link(inputs)
	if (locale === "fr") return fr_multimedia_link(inputs)
	if (locale === "de") return de_multimedia_link(inputs)
	if (locale === "ja") return ja_multimedia_link(inputs)
	if (locale === "zh") return zh_multimedia_link(inputs)
	if (locale === "ar") return ar_multimedia_link(inputs)
	if (locale === "id") return id_multimedia_link(inputs)
	if (locale === "it") return it_multimedia_link(inputs)
	if (locale === "ru") return ru_multimedia_link(inputs)
	if (locale === "pt") return pt_multimedia_link(inputs)
	return ko_multimedia_link(inputs)
});